module.exports = __webpack_public_path__ + "img/08.c0756196.jpg";